__turbopack_context__.v({
  "authorBorder": "CommonHeader-module__5yuTva__authorBorder",
  "blogCommonHeader": "CommonHeader-module__5yuTva__blogCommonHeader",
  "blogHeaderContent": "CommonHeader-module__5yuTva__blogHeaderContent",
  "blogHeaderOverlay": "CommonHeader-module__5yuTva__blogHeaderOverlay",
  "blogHeaderTitle": "CommonHeader-module__5yuTva__blogHeaderTitle",
  "blogMeta": "CommonHeader-module__5yuTva__blogMeta",
  "blogMetaItem": "CommonHeader-module__5yuTva__blogMetaItem",
  "blogMetaItemLink": "CommonHeader-module__5yuTva__blogMetaItemLink",
  "blogMetaShare": "CommonHeader-module__5yuTva__blogMetaShare",
  "blogMetaShareBtn": "CommonHeader-module__5yuTva__blogMetaShareBtn",
  "blogSubtitle": "CommonHeader-module__5yuTva__blogSubtitle",
  "commonHeader": "CommonHeader-module__5yuTva__commonHeader",
  "commonHeaderBtn": "CommonHeader-module__5yuTva__commonHeaderBtn",
  "commonHeaderBtnWrap": "CommonHeader-module__5yuTva__commonHeaderBtnWrap",
  "commonHeaderContainer": "CommonHeader-module__5yuTva__commonHeaderContainer",
  "commonHeaderContent": "CommonHeader-module__5yuTva__commonHeaderContent",
  "commonHeaderHero": "CommonHeader-module__5yuTva__commonHeaderHero",
  "commonHeaderOverlay": "CommonHeader-module__5yuTva__commonHeaderOverlay",
  "commonHeaderTitle": "CommonHeader-module__5yuTva__commonHeaderTitle",
  "metaIcon": "CommonHeader-module__5yuTva__metaIcon",
  "metaIconReact": "CommonHeader-module__5yuTva__metaIconReact",
});
